import type { AnalyticsEvent } from './types';

const KEY = 'fc_viewer_analytics_v1';

export function track(name: string, payload?: Record<string, unknown>): AnalyticsEvent {
  const event: AnalyticsEvent = {
    id: crypto.randomUUID(),
    name,
    createdAt: new Date().toISOString(),
    payload
  };

  try {
    const current = JSON.parse(window.localStorage.getItem(KEY) ?? '[]') as AnalyticsEvent[];
    const next = [...current.slice(-999), event];
    window.localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // Analytics are deliberately non-blocking in the prototype.
  }

  return event;
}

export function getAnalytics(): AnalyticsEvent[] {
  try {
    return JSON.parse(window.localStorage.getItem(KEY) ?? '[]') as AnalyticsEvent[];
  } catch {
    return [];
  }
}

export function clearAnalytics() {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // Ignore storage failures.
  }
}

export function downloadAnalytics() {
  const blob = new Blob([JSON.stringify(getAnalytics(), null, 2)], {
    type: 'application/json'
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = `fallen-cathedral-session-${new Date().toISOString().replace(/[:.]/g, '-')}.json`;
  anchor.click();
  URL.revokeObjectURL(url);
}
